<template>
  <div class="table-settings">
    <div class="table-list-header">
      <div class="text-2xl font-semibold text-vp-base-900">
        Team
      </div>
      <router-link
        :to="{ name: 'UserAccountNew' }"
        class="hover:no-underline"
      >
        <div
          class="flex items-center justify-center fixed bottom-16 right-16 w-14 h-14 sm:h-37 sm:w-30 sm:static bg-vp-primary-900 rounded-full sm:rounded-lg"
        >
          <span class="hidden sm:inline-block text-vp-base-100 text-sm font-semibold">Add</span>
          <Plus class="sm:hidden text-vp-base-100 h-6 w-6" />
        </div>
      </router-link>
    </div>

    <div
      v-if="userAccountLoading"
      class="text-center"
    >
      Loading...
    </div>

    <div
      v-else
      class="table-list"
    >
      <div class="table-list-item">
        <div class="header-name">
          Name
        </div>
        <div class="header-name hidden sm:block">
          Email
        </div>
        <div class="header-name">
          Role
        </div>
      </div>

      <router-link
        v-for="userAccount in usersAccounts"
        :key="userAccount.id"
        :to="{ name: 'UserAccountEdit', params: { userId: userAccount.user.id } }"
        class="table-list-item table-link"
      >
        <div class="table-cell-content">
          {{ userAccount.user.name }}
        </div>
        <div class="table-cell-content hidden sm:block">
          {{ userAccount.user.email }}
        </div>
        <div class="table-cell-content">
          {{ userAccount.teamRole.name }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserAccountsStore } from '@/stores/user-accounts';
import { Plus } from 'mdue';
import { computed } from 'vue';
import { useRootStore } from '@/stores/root';

const rootStore = useRootStore();
const userStore = useUserAccountsStore();
userStore.fetchAllUsersAccounts(rootStore.currentAccountId);
const usersAccounts = computed(() => userStore.usersAccounts);
const userAccountLoading = computed(() => userStore.userLoading);
</script>
